export default "__VITE_ASSET__BCWycRkK__"